import { render, staticRenderFns } from "./TagTypes.vue?vue&type=template&id=1661a222"
import script from "./TagTypes.vue?vue&type=script&lang=ts"
export * from "./TagTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports